const requireContext = require.context('./', true, /^(?!\.\/index).*\.js$/)
const i18n = requireContext.keys().reduce((pre, current) => Object.assign(pre, requireContext(current).default), {})

const index = {
    common: {
        title: 'HZnet remote monitoring platform',
        subTitle: {
            hydro: 'Hydropower cloud',
            power: 'Electric cloud',
            photo: 'Photovolt cloud'
        },
        operator: {
            operator: 'Operate',
            search: 'Search',
            export: 'Export',
            add: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            save: 'Save',
            cancel: 'Cancel',
            deleteConfirm: 'Delete confirm',
            deleteSuccess: 'Delet success!',
            deleteFail: 'Delete fail!',
            addSuccess: 'Add success!',
            editSuccess: 'Edit success!',
            operatorFail: 'Operator fail!',
            saveSuccess: 'Save success!',
            yes: 'yes',
            no: 'no'
        },
        tips: {
            condition: 'Search criteria should be within 16 characters'
        },
        name: {
            startTime: 'Start time',
            endTime: 'End time',
            time: 'Time',
            confirmInfo: 'Confirmation information',
        }
    },
    login: {
        name: 'Login',
        downloadAndroidApp: 'Download android app',
        message: {
            enterUser:'Please enter the user name!',
            enterPwd: 'Please enter password!',
            enterCode:'Please enter passcode',
            userPwdError: 'Wrong username and password!',
            codeError: 'Error in verification code'
        }
    },
    layout: {
        home: 'Home page',
        personSetting: 'Personal settings',
        exit: 'Exit',
        close: 'Close',
        closeOther: 'Close other',
        closeAll: 'Close all'
    },
    //个人信息
    personal: {
        account: 'Account',
        name: 'Name',
        phone: 'Phone',
        email: 'Email',
        oldPwd: 'Old password',
        pwd: 'Password',
        confirmPwd: 'Confirm Password',
        confirm: 'Confirm',
        bandWx: 'Binding WeChat',
        formatPwd: 'Password cannot be empty',
        formatPwd1: 'The password is inconsistent with the confirmation password',
        formatAccount: 'Please enter account',
        formatName: 'Please enter name',
        formatLength: 'length 2~32',
        formatPhone: 'Please enter the normal phone format',
        formatPwd2: '6-20 digits, consisting of letters (case sensitive) and numbers, which can contain special characters',
        formatEmail: 'Email format Error',
        editSuccess: 'Edit success!',
        accountNoExist: 'Account does not exist!',
        oldPwdError: 'Old password Error!',
        accountEditError: 'Account modify fail!'
    },
    system: {
        user: {
            placeholder: 'Please enter an account/name...',
            account: 'Account',
            name: 'Name',
            phone: 'Phone',
            email: 'Email',
            registerTime: 'Register time',
            lastLoginTime: 'Last login time',
            pwd: 'Password',
            confirmPwd: 'Confirm password',
            roleDistribution: 'Role assignment',
            station: 'Site management',
            enterPwd: 'Please enter a password',
            enterConfirmPwd: 'Please enter a confirmation password',
            pwdError: 'Inconsistent password',
            enterAccount: 'Please enter your account number',
            length: 'Length 2 ~ 16',
            enterName: 'Please enter name ',
            formatPhone: 'Please enter the normal phone format ',
            formatPwd: '6-20, consisting of letters (case-sensitive), numeric, and can contain special characters',
            formatEmail: 'Mailbox format error',
            formatLength: 'Length cannot exceed 32 bits',
            entRole: 'Please select the role',
            condition16: 'Search criteria should be within 16 characters',
            addUser: 'Add user',
            userEdit: 'User edit',
            userExist: 'The user name already exists, please re-enter.!'
        },
        role: {
            name: 'Name',
            role: 'Role',
            user: 'User',
            addRole: 'Add role',
            addSuccess: 'Role {newrole} add successfully',
            addExist: 'Role {newrole} already exists',
            addFail: 'Role {newrole} new failed',
            permissionSuccess: 'user assignment for permission {RoleName} was successful',
            permissionFail: 'User assignment for permission {RoleName} failed'
        },
        siteM: {
            name: 'Name',
            group: 'Site group',
            site: 'Site',
            addSite: 'New sitegroup',
            deleteFail: 'Sitegroup{name}delete failed(Please delete the child permissions first)',
            deleteFail1: 'Sitegroup{name}delete failed',
            enterSiteGroup: 'Please enter the sitegroup name',
            length: 'Length 2 ~ 16',
            selectSiteGroup: 'Please select a sitegroup',
            addSuccess: 'Sitegroup{newGroup}add successfully',
            addExist: 'Sitegroup{newGroup}already exists',
            addFail:  'siteGroup{newGroup}new failed',
            clearConfirm: 'Are you sure you want to clear {name} of the sitegroup?',
            distributionSuccess: 'Site allocation for sitegroup {name} was successful',
            distributionFail: 'Site allocation for sitegroup {name} failed',
        },
        setting: {
            file: 'File',
            allSelect: 'Select All',
            unSelect: 'Inverse',
            menu: 'Menu',
            selectFile: "Please select a file!",
            selectMenu: 'Please select the menu!'
        },
        siteS: {
            placeholder: 'Please enter the station name / number...',
            siteName: 'Site name',
            siteCode: 'Site number',
            latlng: 'Longitude and latitude ', 
            remark: 'Remark',
            siteType: 'Site type',
            siteLat: 'Site latitude',
            siteLng: 'Site longitude',
            expireTime: 'Expire Time',
            svnAddress: 'svn address',
            allowControl: 'allow control',
            remark: 'Remark',
            imgUpload: 'Image upload',
            getLagLng: 'Get latitude and longitude',
            selectFile: 'Select file',
            uploadDesc: 'Support for jpg,jpeg,png format up to 2.0m in size',
            placeholder_name: 'Please enter the name of the site',
            placeholder_type: 'Please select a site type',
            placeholder_expireTime: 'Please select expire time',
            placeholder_code: 'Please enter a site number',
            placeholder_lng: 'Please enter the site longitude',
            placeholder_lat: 'Please enter the site latitude',
            placeholder_svn: 'Please enter an svn address',
            placeholder_remark: 'Please enter a note',
            formatLng: 'Incorrect longitude format',
            formatLng1: 'Please enter a site longitude',
            formatLat: 'Incorrect latitude format',
            formatLat1: 'Please enter the site latitude',
            formatName: 'Please enter a name',
            formatLength: 'Length 2 ~ 16',
            formatType: 'Please select a site type',
            formatCode: 'Please enter a site number',
            formatCode1: 'The site number is a number',
            formatCode2: 'The length cannot be more than 16 bits',
            formatRemark: 'The length cannot exceed 250',
            formatUpload: 'File size cannot be greater than 2M,please re-select',
            addUser: 'Add user',
            siteEdit: 'Site edit'
        },
        menu: {
           name: 'Name' ,
           parentMenu: 'Parent menu',
           systemSign: 'System sign',
           link: 'Link',
           isShow: 'Whether to display',
           icon: 'Icon',
           menuType: 'Menu type',
           outerLink: 'Outer link',
           template: 'Template',
           sort: 'Sort',
           placeholder_name: 'Please enter a name',
           placeholder_icon: 'Please enter an icon',
           placeholder_systemSign: 'Please select the system identity',
           placeholder_parentMenu: 'Please select the parent menu',
           placeholder_link: 'Please enter a link',
           placeholder_outerLink: 'Please enter an outerLink',
           placeholder_sort: 'Please enter a sort',
           placeholder_template: 'Please select a template ',
           formatNum: 'Please enter a number less than 100',
           formatName: 'Please enter a name',
           formatLength: 'Length 2 ~ 16',
           formatSort: 'Please sort ',
           formatLength1: 'No more than 200 characters in length',
           addMenu: 'New menu',
           editMenu: 'Edit menu',
        },
        video: {
            name: 'Name',
            type: 'Type',
            address: 'Video point location ',
            source: 'Video source/code',
            station: 'Site',
            control: 'PTZ Control',
            placeholder_name: 'Please enter a name',
            placeholder_type: 'Please select Type',
            placeholder_source: 'Please enter the video source',
            placeholder_address: 'Please enter the location of the video point',
            formatLength: 'Length 2 ~ 16',
            formatType: 'Please select Type',
            formatSource: 'Please enter a video source/ code',
            formatSource1: 'No more than 200 characters in length',
            formatAddress: 'No more than 250 characters in length',
            addVideo: 'New video point',
            editVideo: 'Edit video point',
            platform: 'Platform access'
        },
        device: {
            placeholder: 'Please enter account number / device code...',
            account: 'Account',
            code: 'Device code',
            type: 'Device type',
            createTime: 'Create time',
            auditStatus: 'Audit status',
            audit: 'Audit',
            auditConfirm: 'Are you sure you want to review?',
            pc: 'PC end',
            mobile: 'Moving end',
            audited: 'Audited',
            unaudit: 'Unaudit',
            deleteConfirm: 'Are you sure delete device code'
        },
        auth: {
            name: 'Name',
            role: 'Role',
            menu: 'Menu',
            addRole: 'New roles',
            roleDeleteFail: 'Failed to delete role {name }(delete child permission first)',
            roleDeleteFail1: 'Role {name} delete failed',
            enterRole: 'Please enter a role name',
            length: 'Length 2 ~ 16',
            selectRole: 'Please select a role',
            selectRole1: 'Please select the role',
            RoleExistError: 'Role {newfound} already exists',
            RoleAddError: 'Role {newRole} new failed',
            RoleAddSuccess: 'Role{newRole}new success',
            confirmClearRole: 'Are you sure you want to empty the menu for the role[{name}]',
            roleDistributionSuccess: 'Role {name} menu assigned successfully',
            roleDistributionFail: 'Menu allocation for role {name} failed',
            roleSteSuccess:"Role {name} created successfully"
        },
        
    },
    //数据监测-运行监控
    operation: {
        factory: 'Factory station',
        group: 'Group',
        factoryName: 'Factory name',
        groupName: 'Group name',
        name: 'Telemetry name',
        value: 'Telemetry',
        time: 'Telemetering time',
        placeholder: 'Telemetry name...'
    },
    //历史数据
    history: {
        factory: 'Factory station',
        group: 'Group',
        point: 'Punctuation mark',
        searchType: 'Query type',
        integer: 'Integral point',
        original: 'Original',
        placeholder_point: 'Please select the dot number',
        tips_point: 'Please select the dot number!',
        tips_time: 'Please select a time interval!',
        tips_time1: 'Start time cannot be greater than end time!',
        tips_time2: 'The difference between the start time and the end time can not exceed a month!',
        type: 'Type',
        eventContent: 'Event content',
        warnType: 'Warn type',
        status: 'Status',
        value: 'Operating value',
        all: 'All',
        default: 'Default',
        system: 'System',
        alarm: 'Alarm',
        accident: 'Accident',
        operator: 'Operator',
        telemetry_limit: 'Telemetry_limit',
        telemetry_displacement: 'Telemetry_displacement',
        register_info: 'Register_info',
        info_tips: 'Info_tips',
        equipment_inspect: 'Equipment_inspect',
        operator_record: 'Operator_record',
        spare: 'Spare',
        undefine: 'Undefine'
    },
    //统计分析
    analysis: {
        factory: 'Factory',
        group: 'Group',
        point: 'Punctuation mark', 
        showModel: 'Display mode',
        dimension: 'Dimension',
        statisticsType: 'Statistics type',
        tips_point: 'Please select the dot number!',
        tips_time: 'Please select a time interval!',
        tips_time1: 'Start time cannot be greater than end time!',
        tips_time2: 'The difference between the start time and the end time can not exceed a month!',
        tips_time3: 'The start time and the end time cannot be more than one year!',
        tips_time4: 'The difference between the start time and the end time can not exceed a decade!',
        year: 'Year',
        month: 'Month',
        day: 'Day',
        hour: 'Hour',
        single: 'Single image',
        multi: 'Multiple image',
        avg: 'Average value',
        max: 'Maximal value',
        min: 'Minimum value',
        compareTime: 'Compare time'
    }
}

export default Object.assign({}, index, i18n)


// WEBPACK FOOTER //
// ./src/i18n/langs/en/index.js